import { render, staticRenderFns } from "./TypeTextPanel.vue?vue&type=template&id=56c53c9a&scoped=true"
import script from "./TypeTextPanel.vue?vue&type=script&lang=js"
export * from "./TypeTextPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c53c9a",
  null
  
)

export default component.exports